import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Autocomplete } from '../Autocomplete';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  // DialogContentText,
  DialogActions,
  Button,
  // TextField,
  // Modal,
  // CircularProgress,
  LinearProgress,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = props => ({});

export const ConfirmationDialog = withStyles(styles)(props => {
  const {
    // classes,
    children,
    title,
    subtitle,
    visible,
    setVisibility,
    cancelButton,
    rejectButton,
    acceptButton,
    disabled,
    isSubmitting,
    submitMessage,
    style,
    minHeight,
    minWidth,
    maxWidth,
  } = props;

  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const [submitMessage, setSubmitMessage] = useState(null);

  return (
    <Dialog
      open={visible}
      onClose={() => setVisibility(false)}
      aria-labelledby="form-dialog-title"
      disabled={disabled}
      maxWidth={maxWidth}
    >
      <DialogTitle>{title}</DialogTitle>
      {!!subtitle && <DialogTitle style={{ paddingTop: 0, marginTop: -10 }}>{subtitle}</DialogTitle>}

      {!!children && (
        <DialogContent
          dividers
          style={{
            minWidth: minWidth || 500,
            minHeight: minHeight || 400,
            borderTop: '0.8px solid #ddd',
            borderBottom: '0.8px solid #ddd',
            paddingTop: 20,
            pointerEvents: disabled ? 'none' : 'auto',
            opacity: disabled ? 0.5 : 1,
            ...style,
          }}
        >
          {children}
        </DialogContent>
      )}

      <DialogActions
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '16px 24px',
        }}
      >
        {/* Cancel Button */}
        {cancelButton}

        {/* Loading indicator */}
        <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
          {isSubmitting && <LinearProgress />}
          {submitMessage && <div>{submitMessage}</div>}
        </div>

        {/* Reject Button */}
        {rejectButton}

        {/* Confirmation Button */}
        {acceptButton}
      </DialogActions>
    </Dialog>
  );
});

ConfirmationDialog.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  setVisibility: PropTypes.func.isRequired,
  cancelButton: PropTypes.object.isRequired,
  acceptButton: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  submitMessage: PropTypes.string,
};

ConfirmationDialog.defaultProps = {
  isSubmitting: false,
  submitMessage: null,
};
